  <template >
   <div class="formPosition">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col md="11">
         <span>Escolhe a classe </span>

                 <v-icon large color="green darken-2">forward</v-icon>

<div class="text-center">

    <v-btn   @click="classe(1)" class="ma-2" outlined color="indigo"><v-icon  small color="primary" >filter_1</v-icon> 10ª classe</v-btn>
    <v-btn   @click="classe(2)" class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_2</v-icon> 11ª classe</v-btn>
    <v-btn   @click="classe(3)" class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_3</v-icon> 12ª classe</v-btn>
    <v-btn   @click="classe(4)"
     class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_4</v-icon> 13ª classe</v-btn>
  </div>
      </v-col>
      <v-col md="1">
        <v-btn to="/estudante/menu" color="blue" fab small> <v-icon small color="white">arrow_back</v-icon> </v-btn >
      </v-col>
    </v-row>
  </v-container>
</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({
    actividades: []

  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },

  created () {
    // this.CarregActividades()
  },

  methods: {
    classe (idclasse) {
      this.$store.state.isloading = true
      this.$store.state.idclasse = idclasse
      this.$router.push('estudante-pesquisa')

      //  this.$store.dispatch('setidclasse', idclasse)
    },
    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
        console.log(this.$store.state.actividades)
      } catch (error) {

      }
    }
  }
}
</script>
